import React, { useEffect } from "react";
import Modal from "../Modal";

const getModalWidth = () => {
  if (window.innerWidth >= 768) {
    return "50%";
  } else {
    return "90%";
  }
};

const GotIt = ({ isOpen, onRequestClose, contentLabel, children }) => {
  useEffect(() => {
    const updateWidth = () => {
      const modalContent = document.querySelector(
        ".ReactModal__Content"
      ) as HTMLElement;
      if (modalContent) {
        modalContent.style.width = getModalWidth();
      }
    };

    window.addEventListener("resize", updateWidth);

    // Initial call to set width
    if (isOpen) {
      updateWidth();
    }

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={contentLabel}
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#401a6e",
          width: getModalWidth(),
          margin: 0,
          padding: 0,
          /* Above wallet/XP history portals (10060); SoftOffers "not enough rubies"
           * opens while the shop tab is still mounted. */
          zIndex: 10071,
        },
        overlay: {
          background: "rgba(11, 2, 18, 0.8)",
          zIndex: 10070,
        },
      }}
      ariaHideApp={false}
    >
      <div>
        {children}
        <button
          onClick={onRequestClose}
          style={{
            display: "block",
            margin: "0 auto",
            fontSize: "16px",
            fontFamily: "anton",
            border: "none",
            cursor: "pointer",
            marginBottom: "20px",
            width: "144px",
            height: "40px",
            fontWeight: "600",
            backgroundColor: "#D2FF00",
            color: "#1B062F",
            textAlign: "center",
          }}
        >
          GOT IT
        </button>
      </div>
    </Modal>
  );
};

export default GotIt;
